import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import clsx from 'clsx';

interface Props {
	formik: any;
	fieldName: string;
	label: string;
	tooltipText?: string;
	additionalClasses?: string;
	disabled?: boolean;
}

export const FormCheckbox = (props: Props): React.ReactElement => {
	const { formik, disabled, fieldName, label, tooltipText, additionalClasses } = props;
	const { t } = useTranslation();

	return (
		<div className={clsx('col-6 col-sm-4 col-md-3 fv-row', additionalClasses)}>
			<div className={clsx('form-check fw-bold col-md-12', disabled && 'cursor-not-allowed')}>
				<input
					type="checkbox"
					className={clsx('form-check-input')}
					style={{
						width: 23,
						height: 23
					}}
					disabled={disabled}
					checked={formik.values[fieldName] ?? false} // Ensure checked is never undefined
					{...formik.getFieldProps(fieldName)}
				/>
				<div className="d-flex align-items-center">
					<label className={clsx('form-check-label', disabled && 'cursor-not-allowed')}>{t(label)}</label>
					{
						tooltipText && (
							<WhisperComponent
								isTooltip
								whisperText={tooltipText}
								placement="auto"
								mainText={
									<FontAwesomeIcon
										icon={faQuestionCircle}
										className="ms-1"
										width={12}
									/>
								}
							/>
						)
					}
				</div>
			</div>
			{formik.touched[fieldName] && formik.errors[fieldName] && (
				<div className="fv-plugins-message-container text-danger">
					<div className="fv-help-block">{formik.errors[fieldName]}</div>
				</div>
			)}
		</div>
	);
};

